import { VFC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

type Props = {
  isLoading: boolean;
};

/**
 * ローディング
 * @param isLoading
 * @returns
 */
export const Loading: VFC<Props> = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          position={"absolute"}
          top={0}
          left={0}
          height={"100vh"}
          width={"100vw"}
          zIndex={"9999"}
          bgcolor={"rgb(0, 0, 0, 0.4)"}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};
